export default __webpack_public_path__ + "static/media/rb1.15558763.jpg";